import { AIReconnectButton } from './AIReconnectButton';
import { AppConnectionStatuses } from '../../../../constants/appConnectionStatuses';
import { AIServiceComponent } from './AIServiceComponent';
export const AIReconnectionConfig = {
  reconnectButton: AIReconnectButton,
  statusesForDisplaying: [AppConnectionStatuses.UPDATE_AVAILABLE, AppConnectionStatuses.DISCONNECTED, AppConnectionStatuses.SUNSET, AppConnectionStatuses.UPCOMING_SUNSET],
  serviceComponent: AIServiceComponent
};